<script>
  export let title;
  export let value;
  export let error;
  export let placeholder = title;
  export let isHorizontal = false;
  export let description;
</script>

<div class="field" class:is-horizontal={isHorizontal}>
  <div class:field-label={isHorizontal} class="is-small">
    <label class="label is-small">{title}</label>
  </div>
  <div class="field-body">
    <div class="field">
      <div class="control">
        <input
          class="input is-small"
          type="text"
          {placeholder}
          bind:value
          class:is-danger={error} />
        {#if error}
          <p class="help is-danger">{error}</p>
        {/if}
      </div>
    </div>
  </div>
  {#if description}
    <p class="bp-description">{description}</p>
  {/if}
</div>
